var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavOperations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nav-operations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-operations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3.000000, 3.000000)",
    stroke: "#4B5563",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32463,1.31731 C7.75103,-0.439103 10.249,-0.439103 10.6754,1.31731 C10.9508,2.45193 12.2507,2.99038 13.2478,2.38285 C14.7913,1.44239 16.5576,3.2087 15.6172,4.75218 C15.0096,5.74925 15.5481,7.04918 16.6827,7.32463 C18.4391,7.75103 18.4391,10.249 16.6827,10.6754 C15.5481,10.9508 15.0096,12.2507 15.6172,13.2478 C16.5576,14.7913 14.7913,16.5576 13.2478,15.6172 C12.2507,15.0096 10.9508,15.5481 10.6754,16.6827 C10.249,18.4391 7.75103,18.4391 7.32463,16.6827 C7.04918,15.5481 5.74926,15.0096 4.75219,15.6172 C3.2087,16.5576 1.44239,14.7913 2.38285,13.2478 C2.99038,12.2507 2.45193,10.9508 1.31731,10.6754 C-0.439103,10.249 -0.439103,7.75103 1.31731,7.32463 C2.45193,7.04918 2.99037,5.74926 2.38285,4.75218 C1.44239,3.2087 3.2087,1.44239 4.75219,2.38285 C5.74926,2.99037 7.04918,2.45193 7.32463,1.31731 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9 C12,10.6569 10.6569,12 9,12 C7.34315,12 6,10.6569 6,9 C6,7.34315 7.34315,6 9,6 C10.6569,6 12,7.34315 12,9 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavOperations);
export default __webpack_public_path__ + "static/media/nav-operations.e2fd4f6d32581705baffdea577721c92.svg";
export { ForwardRef as ReactComponent };